import React from 'react'
import { Divider, Icon, Item, Search } from 'semantic-ui-react'
import _,{ map} from 'lodash'
import {Link, withRouter,useHistory} from 'react-router-dom'
import db from '../../utils/firebase'
import { connect } from 'react-redux'
import './Buscador.scss'



 function Buscador() {


    const [initialState, setInitialState] = React.useState({isLoading: false, results: [], value: "", id: "", render: false})
    const [data, setData] = React.useState([])
    const [ident, setIdent] = React.useState({
        id: ""
    })
    const history = useHistory()

    const truncate = (string, n) => string?.length > n ? `${string.substr(0, n-1)} ...` : string 
    const detalle = navigator.userAgent
                        let regExp = /android|iphone|kindle|ipad/i;
                        let isMobile = regExp.test(detalle)


    React.useEffect(() =>{
        if(initialState?.value?.length >0){
                 peticionBusqueda()
          
        }
        
    },[initialState.value])

    const peticionBusqueda =async ()=>{

      await  db.collection("peliculas").where("buscar","array-contains",initialState?.value).get().then((response)=>{
      
            if(response.docs.length>0){
                const result = response.docs.map((doc)=>{
                    const data = doc.data()
                    
                    return{
                        title:data.title,
                        description:truncate(data.description,50),
                        image:data?.urlPoster,
                        uuidPoster:data?.uuidPoster,
                        id:data?.uuidPoster,
                        pelicula:true,
                        serie:false
                    }

                })
                setData(result)
               // setIdent({...ident,id:result[0].uuidPoster})
               setInitialState({isLoading:false,results:result})
               // setInitialState({...initialState,results:result,isLoading:false})
            }else{

                db.collection("peliculas").where("title","==",initialState.value).get().then((response=>{
                    if(response.docs.length>0){
                        const result = response.docs.map((doc)=>{
                            const data = doc.data()
                            
                            return{
                                title:data.title,
                                description:truncate(data.description,50),
                                image:data?.urlPoster,
                                uuidPoster:data?.uuidPoster,
                                id:data?.uuidPoster,
                                pelicula:true,
                                serie:false
                            }
    
                        })
                        setData(result)
                       // setIdent({...ident,id:result[0].uuidPoster})
                       setInitialState({isLoading:false,results:result})
                       // setInitialState({...initialState,results:result,isLoading:false})
                    }else{
                        
                  //  setInitialState({value:"",results:[],isLoading:false})
                    }
                }))



            }

        })

    await db.collection("series").where("buscar","array-contains",initialState.value).get().then((response)=>{

        if(response.docs.length>0){
            const result = response.docs.map((doc)=>{
                const data = doc.data()
                
                return{
                    title:data.title,
                    description:truncate(data.description,50),
                    image:data?.urlPoster,
                    uuidPoster:data?.uuidPoster,
                    id:data?.uuidPoster,
                    pelicula:false,
                    serie:true
                }

            })
            setData(result)
           // setIdent({...ident,id:result[0].uuidPoster})
           setInitialState({isLoading:false,results:result})
           // setInitialState({...initialState,results:result,isLoading:false})
        }else{

            db.collection("series").where("title","==",initialState.value).get().then((response=>{
                if(response.docs.length>0){
                    const result = response.docs.map((doc)=>{
                        const data = doc.data()
                        
                        return{
                            title:data.title,
                            description:truncate(data.description,50),
                            image:data?.urlPoster,
                            uuidPoster:data?.uuidPoster,
                            id:data?.uuidPoster,
                            pelicula:false,
                            serie:true
                        }

                    })
                    setData(result)
                   // setIdent({...ident,id:result[0].uuidPoster})
                   setInitialState({isLoading:false,results:initialState.results.concat(result)})
                   // setInitialState({...initialState,results:result,isLoading:false})
                }else{

                    //setInitialState({isLoading:false,results:initialState.results})
                }
            }))



        }

    })


    }

    
    

    const handleResultSelect = (e,result) =>{
        if(result?.result.pelicula){

            history.push(`/pelicula/${result?.result?.id}`)
        }
        if(result?.result.serie){
            history.push(`/serie/${result?.result?.id}`)

            
        }


        /*

       // to={ ident.id && `/pelicula/${ident.id}`}


        setInitialState({...initialState, value: result.result.title,})
        setIdent({...ident, id: result.result.id})

        setTimeout(() =>{

            if(result.result.title)return setInitialState({...initialState, value: ""})

            

        },500)

        */
    
        
    }

   

    const onChange = (e,texto)=>{
        const textoMinuscula = texto.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,"")

        

        if(texto){
            setInitialState({...initialState,
            value:textoMinuscula ,
            isLoading:true
            })

        }else{
            setInitialState({...initialState,
                value:"",
                isLoading:false
                })
            
        }

    }

    /*
 setFormData({...formData,
            [e.target.name] : e.target.value})

    */

        //    to={ ident.id && `/pelicula/${ident.id}`} > 


    return (

                         <Search
                             input={{icon: "search", iconPosition: "left"}}
                             loading = {initialState.isLoading}
                             onResultSelect={(e, result) => handleResultSelect(e,result) }
                             onSearchChange={(e,texto)=>onChange(e,texto.value)}
                          //   onSelectionChange={(e,value) => handleSelectChange(e,value)}
                             results={initialState.results} 
                             className='conatinerSearch'
                             
                                 
                        />
      
        
    )
}



export default  withRouter(Buscador)